import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';
import useGetShoppingCartQuery from '../../../../queries/useGetShoppingCartQuery';
import useAuthStore from '../../../../store/authStore';
import useHomeStore from '../../../../store/homeStore';

const useHeaderState = () => {
  const {
    showPricingModal,
    showContactModal,
    setShowCart,
    showCart,
    setShowLogin,
    showLogin,
    showDownloadApiModal,
    showAdvertisingBanner,
    showFeaturesModal,
    advertisingBannerButtonText,
  } = useHomeStore();
  const isPaymentSuccessRoute = useMatch({
    path: '/paymentsuccess',
    end: true,
  });

  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const shoppingCart = useGetShoppingCartQuery();

  useEffect(() => {
    if (!isAuthenticated) return;

    if (!isPaymentSuccessRoute) {
      shoppingCart.refetch();
      return;
    }

    const timer = setTimeout(() => {
      shoppingCart.refetch();
    }, 5000);

    return () => clearTimeout(timer);
  }, [isAuthenticated, isPaymentSuccessRoute]);

  const handleCart = () => {
    if (isAuthenticated) {
      setShowCart(!showCart);
    } else {
      setShowLogin(!showLogin);
    }
  };

  return {
    showPricingModal,
    showContactModal,
    showDownloadApiModal,
    showFeaturesModal,
    showCart,
    showLogin,
    advertisingBannerButtonText,
    isAuthenticated,
    shoppingCart,
    handleCart,
    showAdvertisingBanner,
  };
};

export default useHeaderState;
